import {useNavigate} from "react-router";

export const Footer = () => {
    const footer_items = [
        {label: "Privacy policy", href:"/en/policy"},
        {label: "Terms of Use", href:"/en/terms"},
        {label: "Cookies", href:"/en/cookies"},
        {label: "Imprint", href:"/en/imprint"},
    ]
    const history = useNavigate();
    return(
        <div className={"footer"}>
            <footer>
                <div className={"footer-container"}>
                    <div className={"footer-items"}>
                        {
                            footer_items.map((item, index) => {
                                return(
                                    <a key={index} onClick={() => {history(item.href); window.scrollTo(0,0)}} style={{cursor:"pointer", color:"#1B1A19"}}>{item.label}</a>
                                )
                            })
                        }
                        <button id="ot-sdk-btn" className="ot-sdk-show-settings" style={{background:"none", fontWeight:600, color:"#1B1A19", textAlign:"left", padding:0, fontSize:14, border:"none"}}></button>
                    </div>
                    <p className={"top-line"} style={{textAlign:"center", fontSize:"14px", marginBottom:"24px", width:"100%", color:"#1B1A19"}}>© 2024 Henkel Jebel Ali FZCO</p>
                </div>
            </footer>
        </div>
    )
}
